import API from './apiConfig';

export const postHealthDeclarationById = async (formData) => {
    const id = localStorage.getItem("participant_id")
      ? JSON.parse(localStorage.getItem("participant_id"))
      : "0000";
    try {
      const response = await API.post(`/health/${id}`, formData);
      return response.data;
    } catch (error) {
      console.error(`Error fetching student ${id}:`, error);
      throw error;
    }
  };
  
  export const updateHealthDeclarationById = async (formData) => {
    const id = localStorage.getItem("participant_id")
      ? JSON.parse(localStorage.getItem("participant_id"))
      : "0000";
    try {
      const response = await API.put(`/health/${id}`, formData);
      return response.data;
    } catch (error) {
      console.error(`Error fetching student ${id}:`, error);
      throw error;
    }
  };
  
  export const getHealthDeclarationById = async () => {
    const id = localStorage.getItem("participant_id")
      ? JSON.parse(localStorage.getItem("participant_id"))
      : "0000";
    try {
      const response = await API.get(`/health/${id}`);
      return response.data.data;
    } catch (error) {
      console.error(`Error fetching student ${id}:`, error);
      throw error;
    }
  };
  